import { render, staticRenderFns } from "./IncreaseNumber.vue?vue&type=template&id=98a16598&"
import script from "./IncreaseNumber.vue?vue&type=script&lang=js&"
export * from "./IncreaseNumber.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('98a16598')) {
      api.createRecord('98a16598', component.options)
    } else {
      api.reload('98a16598', component.options)
    }
    module.hot.accept("./IncreaseNumber.vue?vue&type=template&id=98a16598&", function () {
      api.rerender('98a16598', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-28MIQQHqnYCA0/JS/comp/IncreaseNumber.vue"
export default component.exports